/**
 * SEO déclaratif par route.
 * Utilise le support natif React 19 pour les balises document metadata
 * (<title>, <meta>, <link> sont automatiquement hoistés dans <head>
 * et dédupliqués — pas besoin de react-helmet).
 *
 * https://react.dev/reference/react-dom/components/title
 */
export default function SEOHead({
  title,
  description,
  path = "/",
  image = "https://gmcrenovationfacade.fr/og-image.jpg",
  noindex = false,
}) {
  const canonical = `https://gmcrenovationfacade.fr${path}`;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta
        name="robots"
        content={noindex ? "noindex, follow" : "index, follow"}
      />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </>
  );
}
